import { render, staticRenderFns } from "./EditUsers.vue?vue&type=template&id=0ffb28af"
import script from "./EditUsers.vue?vue&type=script&lang=js"
export * from "./EditUsers.vue?vue&type=script&lang=js"
import style0 from "./EditUsers.vue?vue&type=style&index=0&id=0ffb28af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VSelect,VSkeletonLoader,VTextField})
